
const htmlElements = {

    //Create HTML Element
    createElement(elementType, attributes, message = ''){

        //Create HTML Element
        let element = elementType !== 'htmlelement' ? document.createElement(elementType) : document.createElement('div');

        //Set Attributes
        if(typeof attributes === 'object'){

            //Relatede Attributes List and Attributes Values
            for(const [key, value] of Object.entries(attributes)){

                //Replace Value
                let checkkey = key.includes("_") ? key.replace("_", "-") : key;

                element.setAttribute(checkkey, value);

            }

            //Check Type of the Element and add Context
            switch(elementType){

                case 'label':
                case 'button':
                case 'strong':
                case 'legend':
                case 'span':
                case 'textarea':
                case 'li':
                case 'a':
                case 'p':
                case 'option':
                case 'small':                                        

                    element.textContent = message;

                break;

                case 'htmlelement':

                    //Pre tag Element
                    let pre = document.createElement('pre');
                    pre.setAttribute('id', `${attributes.id}_htmleditor_pre`);
                    pre.setAttribute('class', `${attributes.id}_htmleditor_pre`);
                    pre.style.height = '20rem';
                    pre.style.width = '50%';
                    pre.style.overflowX = 'hidden';
                    pre.style.overflowY = 'auto';
                    pre.style.borderRadius = '10px';
                    pre.style.border = '.1rem solid #e8e8e8';
                    element.appendChild(pre);
                    
                    //Code Default tag Element
                    let codeElement = document.createElement('code');
                    codeElement.setAttribute('id', `${attributes.id}_htmleditor_code_default`);
                    codeElement.setAttribute('class', `${attributes.id}_htmleditor_code_default`);
                    codeElement.setAttribute('contenteditable', true);
                    codeElement.setAttribute('onselectstart', "return false");
                    codeElement.style.height = '100%';
                    codeElement.style.width = '100%';
                    codeElement.style.display = 'block';

                    if(attributes.value.length > 0){

                        $(attributes.value).appendTo(codeElement);

                    }
                    
                    pre.appendChild(codeElement);
                    
                    //Code Clone tag Element
                    let codeElementClone = document.createElement('code');
                    codeElementClone.setAttribute('id', `${attributes.id}_htmleditor_code_clone`);
                    codeElementClone.setAttribute('class', `${attributes.id}_htmleditor_code_clone`);
                    codeElementClone.style.height = '20rem';
                    codeElementClone.style.width = '50%';
                    codeElementClone.style.display = 'block';
                    codeElementClone.style.borderRadius = '10px';
                    codeElementClone.style.border = '.1rem solid #e7e7e7';
                    codeElementClone.style.overflowX = 'hidden';
                    codeElementClone.style.overflowY = 'auto';

                    element.appendChild(codeElementClone);
                    
                break;

            }

            return element;

        }

        throw new Error('Please inform an array for attributes list and attributes value');

    }

};

export default htmlElements;